import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router"
import { redirectToError } from "../utils/error-handling"
import { Location } from "@angular/common"

@Injectable()
export class CollectionStudentAccessGuard implements CanActivate {
    constructor(private router: Router) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (route.queryParams.student) {
            this.router.navigate(["/student/"])
            return false
        }
        return true
    }
}
